export const TabVisibilityConfig = {
  RESOURCE_TWO: { hideWhenCanEditFalse: true },
  RESOURCE_THREE: { hideWhenCanEditFalse: true },
  ATTACHMENT: { hideWhenCanEditFalse: true },
  RESOURCE_FOUR: { hideWhenCanEditFalse: true },
  RESOURCE_FIVE: { hideWhenCanEditFalse: true },
  COMMUNICATION: { hideWhenCanEditFalse: true },
};
